export default __webpack_public_path__ + "static/live-bio-25fffd3264010a2a5d23a0a0102001f6.jpg";